import React from "react";
import { api, API_BASE } from "@/lib/api";
import { toast } from "sonner";
import { Download, Trash2 } from "lucide-react";

export default function AdminApplications() {
  const [items, setItems] = React.useState([]);
  const load = () => api.get("/applications").then((r) => setItems(r.data));
  React.useEffect(() => { load(); }, []);

  const download = async (item) => {
    try {
      const token = localStorage.getItem("skyverra_token");
      const res = await fetch(`${API_BASE}/applications/${item.id}/resume`, { headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok) throw new Error("Fail");
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = item.resume_filename || `${item.name}-resume`;
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      toast.error("Failed to download");
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Delete this application?")) return;
    await api.delete(`/applications/${id}`);
    load();
  };

  return (
    <div>
      <div className="overline text-[color:var(--sky-cyan)]">Careers</div>
      <h1 className="mt-3 font-display font-black text-white text-3xl">Applications</h1>
      <p className="mt-2 text-[color:var(--sky-admin-muted)]">Review resumes submitted through your careers page.</p>

      <div className="mt-8 grid gap-3">
        {items.map((a) => (
          <div key={a.id} className="admin-card p-5">
            <div className="flex items-start justify-between gap-4 flex-wrap">
              <div className="min-w-0">
                <div className="font-display font-bold text-white text-lg">{a.name}</div>
                <div className="text-xs text-[color:var(--sky-admin-muted)] mt-0.5">Applied for <span className="text-[color:var(--sky-cyan)] font-semibold">{a.job_title}</span> · {new Date(a.created_at).toLocaleString()}</div>
                <div className="text-sm text-[color:var(--sky-admin-muted)] mt-3 flex flex-wrap gap-4">
                  <span><span className="text-white/70">Email:</span> {a.email}</span>
                  {a.phone && <span><span className="text-white/70">Phone:</span> {a.phone}</span>}
                </div>
                {a.cover_letter && <p className="mt-3 text-sm text-white/80 whitespace-pre-wrap">{a.cover_letter}</p>}
              </div>
              <div className="flex gap-2">
                <button onClick={() => download(a)} className="admin-btn inline-flex items-center gap-2 text-xs"><Download size={13} /> Resume</button>
                <button onClick={() => remove(a.id)} className="admin-btn-ghost text-xs text-red-300 hover:text-red-200"><Trash2 size={13} /></button>
              </div>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="admin-card p-8 text-center text-[color:var(--sky-admin-muted)]">No applications yet.</div>}
      </div>
    </div>
  );
}
